<div class="container">
  <div class="row">
    <div class="col-sm-12">
      <h1 class="main-heading">Depósitos y dependencias</h1>
    </div>
  </div>
  <mat-card>
    <mat-card-content>
      <div class="back-url">
        <button mat-flat-button color="primary" [routerLink]="backUrl">Volver</button>
      </div>
       <div class="company-type">
        <span>Actividades vinculadas exclusivamente a la comercialización</span>
        <div class="row mb-1">
          <mat-radio-group aria-label="" required (change)="onUnicamenteComercializacion($event)" [(ngModel)]="selectedValue" >
            <mat-radio-button [value]="true"> Sí </mat-radio-button>
            <mat-radio-button 
              [value]="false"> No </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="otras-actividades" *ngIf="selectedValue === false">
        <h4 class="secondary-header secondary-header-boder">Otras actividades</h4>
        <mat-checkbox [checked]="comercializacion"
          (change)="onComercializacion($event.checked)">Comercialización</mat-checkbox>
      </div>
      <mat-stepper>
        <mat-step label="Laboratorios">
          <div *ngIf="showLab">
            <rpe-registro-actividad-laboratorio-tabs-form [actividadLaboratorioTabsInput]="labsInput"
              (showLabEvent)="onSuccess()"></rpe-registro-actividad-laboratorio-tabs-form>
          </div>
        </mat-step>
        <mat-step label="Sitios de procesamiento">
          <div *ngIf="showSitioProcesamiento">
            <rpe-registro-actividad-sitios-procesamiento-tabs-form
              [actividadesSitioProcesamientoTabsInput]="sitiosYMaquinasMoviles"
              (showSPEvent)="onSuccess()"></rpe-registro-actividad-sitios-procesamiento-tabs-form>
          </div>
        </mat-step>
        <mat-step label="Depósitos">
          <div *ngIf="showDeposito">
            <rpe-registro-actividad-almacenamiento-tabs [actividadDepositoInput]="depositosYDependencias"
              (showDepositoEvent)="onSuccess()"></rpe-registro-actividad-almacenamiento-tabs>
          </div>
        </mat-step>
        <mat-step label="Viveros">
          <div *ngIf="showVivero">
            <!-- <rpe-viveros-form [formInput]="formInputViveros" (showEvent)="onSuccess()"></rpe-viveros-form> -->
            <rpe-registro-actividad-viveros-form [formInput]="viverosInput"></rpe-registro-actividad-viveros-form>
          </div>
        </mat-step>
      </mat-stepper>
    </mat-card-content>
  </mat-card>
</div>
